import { PureKnockoutView } from '@bingads-webui/knockout-view';
import template from './template.pug';
import ViewModel from './viewmodel';

/**
 * Provide display for bulk edit preview result
 */
export class PreviewResultView extends PureKnockoutView {
  /**
   * Initialize view settings
   * @param {Object} param - An object containing these default options for model
   * @param {String[]} param.columns - localized headers
   * @param {Object[]} param.results - results to display, one per row
   *   the format should be the result of any (similar) function from format-preview-from-response
   * @param {number} param.totalCount - total results count, by default to be results.length
   * @param {Object} param.i18n - localization functions
   *
   * @returns {void} void
   */
  initialize({
    columns,
    results = [],
    totalCount,
    i18n,
  }) {
    this.options = {
      results, columns, i18n, totalCount,
    };
    super.initialize(this.options);
  }

  get template() {
    return template;
  }

  get ViewModel() {
    return ViewModel;
  }

  /**
   * Update the preview results, view will be updated
   * @param {Object[]} results - new results
   *   the format should be the result of any (similar) function from format-preview-from-response
   * @param {number} totalCount - total results count, by default to be results.length
   *
   * @returns {void} void
   */
  update(results, totalCount) {
    this.viewModel.updateResult(results, totalCount);
  }
}
